import { ChildMachineConfig } from "@checkout/types";
import { ActionTypes } from "./actions";
import { GuardTypes } from "./guards";
import { VipSupportState } from "./types";

export const getVipSupportMachine = (config: ChildMachineConfig) => ({
  initial: VipSupportState.route,
  states: {
    [VipSupportState.route]: {
      always: [
        {
          target: VipSupportState.addProduct,
          cond: GuardTypes.hasVipSupportAddedAndEnabled,
        },
        {
          target: config.nextState,
        },
      ],
    },
    [VipSupportState.addProduct]: {
      always: [
        {
          actions: ActionTypes.addVipSupport,
          target: config.nextState,
        },
      ],
    },
  },
});
